import { AppRouteNames } from "@/shared/@types/AppRouteNames";
import { FbsCustomerType } from "@/app/fbs-hub-app/shared/@types/FbsCustomerType";

const ROUTE_PERMISSION_MAP: Record<
  string | symbol,
  (
    fbsCustomerType: FbsCustomerType,
    gasContainerHasMeterContract: boolean,
  ) => boolean
> = {
  // accessible to all fbs customer types
  [AppRouteNames.FbsHubStart]: () => true,
  [AppRouteNames.FbsHubNotFound]: () => true,
  [AppRouteNames.FbsHubAddCustomer]: () => true,

  // accessible to all fbs customer types except autogas
  [AppRouteNames.FbsHubDocuments]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.AutogasCustomer,
  [AppRouteNames.FbsHubWestfalengasBio]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.AutogasCustomer,

  // accessible to all fbs customer types except multi-meter and unknown customers
  [AppRouteNames.FbsHubGasContainers]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.MultiMeterCustomer &&
    fbsCustomerType !== FbsCustomerType.UnknownCustomer,
  [AppRouteNames.FbsHubOrders]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.MultiMeterCustomer &&
    fbsCustomerType !== FbsCustomerType.UnknownCustomer,

  // accessible to all fbs customer types except multi-meter, autogas and unknown customers
  [AppRouteNames.FbsHubCheckout]: (fbsCustomerType) =>
    fbsCustomerType !== FbsCustomerType.MultiMeterCustomer &&
    fbsCustomerType !== FbsCustomerType.AutogasCustomer &&
    fbsCustomerType !== FbsCustomerType.UnknownCustomer,

  // accessible to meter customers only
  [AppRouteNames.FbsHubMeterReport]: (
    fbsCustomerType,
    gasContainerHasMeterContract,
  ) =>
    (fbsCustomerType === FbsCustomerType.SingleMeterCustomer ||
      fbsCustomerType === FbsCustomerType.MultiMeterCustomer) &&
    gasContainerHasMeterContract,
  [AppRouteNames.FbsHubMonthlyPayment]: (
    fbsCustomerType,
    gasContainerHasMeterContract,
  ) =>
    (fbsCustomerType === FbsCustomerType.SingleMeterCustomer ||
      fbsCustomerType === FbsCustomerType.MultiMeterCustomer) &&
    gasContainerHasMeterContract,

  // accessible to order customers only
  [AppRouteNames.FbsHubPriceCockpit]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.NonBioOrderCustomer ||
    fbsCustomerType === FbsCustomerType.BioOrderCustomer,

  // accessible to bio order customers only
  [AppRouteNames.FbsHubWestfalengasBioTariff]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.BioOrderCustomer,

  // accessible to autogas customers only
  [AppRouteNames.FbsHubAutogasMeterReport]: (fbsCustomerType) =>
    fbsCustomerType === FbsCustomerType.AutogasCustomer,
};

export const checkFbsPermission = (
  route: string | symbol | undefined,
  fbsCustomerType: FbsCustomerType | undefined,
  gasContainerHasMeterContract: boolean,
) => {
  if (!route || !fbsCustomerType) return false;

  const permissionCheck = ROUTE_PERMISSION_MAP[route];
  return permissionCheck
    ? permissionCheck(fbsCustomerType, gasContainerHasMeterContract)
    : false;
};
